<template>
  <div class="not-login-box" v-show="!Getter_Token">
    <router-link to="/login?redirect=%2Fexchange" class="operate-link mr-2">{{ $t('actions.login') }}</router-link>
    <span class="light-grey">{{ $t('labels.or') }}</span>
    <router-link :to="{  name: 'register' }" class="operate-link ml-2 mr-2">{{ $t('actions.register') }}</router-link>
    <span class="light-grey">{{ $t('labels.trade.startTrade') }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getterTypes } from '@/store/getter-types';
export default {
  name: 'LoginTips',
  computed: {
    ...mapGetters([getterTypes.Getter_Token]),
  },
  methods: {
  },
};
</script>
<style lang="stylus" scoped>
.not-login-box {
  font-size: 0.85rem;  
}
.light-grey {
  color: #d3d7e8;
}
</style>
